import { render, staticRenderFns } from "./ques-item.vue?vue&type=template&id=7915b0d6&scoped=true&"
import script from "./ques-item.vue?vue&type=script&lang=js&"
export * from "./ques-item.vue?vue&type=script&lang=js&"
import style0 from "./ques-item.vue?vue&type=style&index=0&id=7915b0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7915b0d6",
  null
  
)

export default component.exports